module.exports = __webpack_public_path__ + "img/icon_success.f2302d98.png";